import MojitoCore from 'mojito/core';
import MatchEventCardClassic from './classic/index.js';
import MatchEventCardAvantgarde from './avantgarde/index.js';

const UIViewFamily = MojitoCore.Presentation.UIViewFamily;

/**
 * Match event card. Renders
 * {@link Mojito.Modules.EventCards.Match.Classic.view|MatchEventCardClassic} or
 * {@link Mojito.Modules.EventCards.Match.Avantgarde.view|MatchEventCardAvantgarde} depending on the
 * active design style. Props are defined on
 * {@link Mojito.Modules.EventCards.Match.Classic.view|MatchEventCardClassic} and
 * {@link Mojito.Modules.EventCards.Match.Avantgarde.view|MatchEventCardAvantgarde}.
 *
 * @function MatchEventCard
 * @name view
 *
 * @memberof Mojito.Modules.EventCards.Match
 */
export default UIViewFamily('MatchEventCard', {
    classic: MatchEventCardClassic,
    avantgarde: MatchEventCardAvantgarde,
});
